'use client';
import { freddyTheme } from '@coolblue-development/freddy';
import { Plus } from '@coolblue-development/icons';

export default function ConfiguratorPlusIcon() {
  return <Plus color={freddyTheme.color.icon.subtle} />;
}
